module.exports = __webpack_public_path__ + "static/media/header.94f56d9f.jpg";